import { render, staticRenderFns } from "./DateTime.vue?vue&type=template&id=c048601a"
import script from "./DateTime.vue?vue&type=script&lang=js"
export * from "./DateTime.vue?vue&type=script&lang=js"
import style0 from "./DateTime.vue?vue&type=style&index=0&id=c048601a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports